import type { ApiResponse } from '@/store/types'
import { post, uploadToS3 } from '@/backend/api'
import type { ErrorWithMessage } from '@/backend/error'
import { errorMessages, isErrorResponse, parseError } from '@/backend/error'

type Params = {
  upload_url: string
  content: File
  type: string | null
}

export const uploadProfileAvatar = async (
  params: Params,
): Promise<ApiResponse<null> | { error: ErrorWithMessage }> => {
  try {
    await uploadToS3(params.upload_url, params.content, params.type)
    await post('users/confirm_avatar_uploaded')
    return { data: null }
  } catch (error) {
    if (!isErrorResponse(error)) {
      throw error
    }
    return parseError(error, errorMessages.PROFILE_UPDATE) as { error: ErrorWithMessage }
  }
}
